const termsCheckbox = document.querySelector( '.login__consent--disable' );
const formButton = document.querySelector( '.woocommerce-form-login__submit' );

function toggleButton() {
	if ( termsCheckbox.checked ) {
		formButton.disabled = false;
	} else {
		formButton.disabled = true;
	}
}
if ( termsCheckbox ) {
	toggleButton();

	termsCheckbox.addEventListener( 'change', function() {
		toggleButton();
	} );
}
